// ** React Imports
import { Fragment, lazy } from "react"
import { Navigate } from "react-router-dom"
// ** Layouts
import BlankLayout from '../../@core/layouts/BlankLayout'
import VerticalLayout from "../../layouts/VerticalLayout"
import HorizontalLayout from "../../layouts/HorizontalLayout"
import LayoutWrapper from "../../@core/layouts/components/layout-wrapper"

// ** Route Components
import PublicRoute from "../../@core/components/routes/PublicRoute"

// ** Utils
import { isObjEmpty, isUserLoggedIn } from "../../utility/Utils"
import Error from "../../views/Pages/Error"
import UsersList from "../../views/Dashboard/UsersList"
// import UsersCompanyMapping from "../../views/Dashboard/UsersCompanyMapping"
import CompaniesList from "../../views/Dashboard/CompaniesList"
import ActiveUser from "../../views/Dashboard/ActiveUser"
//import ActiveUserEdit from "../../views/Dashboard/ActiveUserEdit"
import ActiveCompany from "../../views/Dashboard/ActiveCompany"
import PageRefresh from "../../views/PageRefresh"
import ActiveUserDesign from "../../views/Dashboard/ActiveUserDesign"
// import VerificationDetails from "../../views/Dashboard/VerificationDetails"
// import RoleManagement from "../../views/Dashboard/RolesManangement/RoleMaagement"
import MainRoleManagement from "../../views/Dashboard/MainRoleManag"
import VeselList from "../../views/Dashboard/VesselsList"
import ActiveVesel from "../../views/Dashboard/ActiveVesel"
const MyProfile = lazy(() => import("../../views/MyProfile"))

const MainRoleManag = lazy(() => import("../../views/Dashboard/MainRoleManag"))


const getLayout = {
  blank: <BlankLayout />,
  vertical: <VerticalLayout />,
  horizontal: <HorizontalLayout />
}

// ** Document title
// const TemplateTitle = "%s - Vuexy React Admin Template"
const TemplateTitle = 'Contact Management'

// ** Default Route

let DefaultRoute = "/dashboard"

let Routes = []

const getRouteMeta = (route) => {
  if (isObjEmpty(route.element.props)) {
    if (route.meta) {
      return { routeMeta: route.meta }
    } else {
      return {}
    }
  }
}

// ** Return Filtered Array of Routes & Paths
const MergeLayoutRoutes = (layout, defaultLayout) => {
  const LayoutRoutes = []
  if (isUserLoggedIn()) {
    if (JSON.parse(isUserLoggedIn()).isEmployee) {
      let sessionRoute = sessionStorage.getItem('UrlPath')
      if (sessionRoute === '/Unauthorized') {
        const userData = JSON.parse(localStorage.getItem('userData'))
        const userRoles = userData && userData.userRoles
        if (userRoles && userRoles.length > 0) {
          sessionRoute = '/userslist'
        }
      }

      // DefaultRoute = sessionRoute ? sessionRoute : '/dashboard'
      DefaultRoute = '/userslist'
      // **Employee Merge Routes
      const employeeRoutes = [
        {
          path: "/",
          index: true,
          element: <Navigate replace to={DefaultRoute} />
        },
        // {
        //   path: "/userslist",
        //   element: <Dashboard />
        // },
        // {
        //   path: "/userList/:id",
        //   element: <ActiveUserEdit></ActiveUserEdit>
        // },
        {
          path: "/user/:id",
          element: <ActiveUserDesign></ActiveUserDesign>
        },
        {
          path: "/company/:id",
          element: <ActiveCompany></ActiveCompany>
        },
        {
          path: "/userslist",
          element: < UsersList />
        },
        {
          path: "/companieslist",
          element: < CompaniesList />
        },
        // {
        //   path: "/usercompaniesmapping",
        //   element: < UsersCompanyMapping />
        // },
        {
          path: "/waypoint",
          element: <Error />
        },
        {
          path: "/waypoint-cloud",
          element: <Error />
        },
        {
          path: "/my-profile",
          element: <MyProfile />
        },
        {
          path: '/pageRefresh',
          element: <PageRefresh />
        },
        {
          path: "*",
          element: <Error />
        },
        {
          path: "/role-management",
          element: <MainRoleManagement />
        },
        {
          path: "/veselsList",
          element: <VeselList />
        },
        {
          path: "/veselUser/:id",
          element: <ActiveVesel />
        }
      ]
      Routes = employeeRoutes
    } else {
      // **Customer Merge Routes

      let customerRoutes = []

      DefaultRoute = '/userslist'
      customerRoutes = [
        {
          path: "/",
          index: true,
          element: <Navigate replace to={DefaultRoute} />
        },
        {
          path: "/user/:id",
          element: <ActiveUserDesign></ActiveUserDesign>
        },
        {
          path: "/company/:id",
          element: <ActiveCompany></ActiveCompany>
        },
        {
          path: "/userslist",
          element: < UsersList />
        },
        {
          path: "/companieslist",
          element: < CompaniesList />
        },
        // {
        //   path: "/usercompaniesmapping",
        //   element: < UsersCompanyMapping />
        // },
        {
          path: "/waypoint",
          element: <Error />
        },
        {
          path: "/waypoint-cloud",
          element: <Error />
        },
        {
          path: "/my-profile",
          element: <MyProfile />
        },
        {
          path: '/pageRefresh',
          element: <PageRefresh />
        },
        {
          path: "*",
          element: <Error />
        }, {
          path: "/role-management",
          element: <MainRoleManagement />
        },
        {
          path: "/veselsList",
          element: <VeselList />
        },
        {
          path: "/veselUser/:id",
          element: <ActiveVesel />
        }
      ]

      Routes = customerRoutes
    }
  }
  if (Routes) {
    Routes.filter((route) => {
      let isBlank = false
      // ** Checks if Route layout or Default layout matches current layout
      if (
        (route.meta && route.meta.layout && route.meta.layout === layout) ||
        ((route.meta === undefined || route.meta.layout === undefined) &&
          defaultLayout === layout)
      ) {
        const RouteTag = PublicRoute

        // ** Check for public or private route
        if (route.meta) {
          route.meta.layout === "blank" ? (isBlank = true) : (isBlank = false)
        }
        if (route.element) {
          const Wrapper =
            // eslint-disable-next-line multiline-ternary
            isObjEmpty(route.element.props) && isBlank === false
              ? // eslint-disable-next-line multiline-ternary
              LayoutWrapper
              : Fragment

          route.element = (
            <Wrapper {...(isBlank === false ? getRouteMeta(route) : {})}>
              <RouteTag route={route}>{route.element}</RouteTag>
            </Wrapper>
          )
        }

        // Push route to LayoutRoutes
        LayoutRoutes.push(route)
      }
      return LayoutRoutes
    })
  }
  return LayoutRoutes
}

const getRoutes = (layout) => {
  const defaultLayout = layout || "vertical"
  const layouts = ["vertical", "horizontal", "blank"]

  const AllRoutes = []

  layouts.forEach((layoutItem) => {
    const LayoutRoutes = MergeLayoutRoutes(layoutItem, defaultLayout)

    AllRoutes.push({
      path: "/",
      element: getLayout[layoutItem] || getLayout[defaultLayout],
      children: LayoutRoutes
    })
  })
  return AllRoutes
}

export { DefaultRoute, TemplateTitle, Routes, getRoutes }
